export default {"src":"/_next/static/media/apple.9cf4533f.svg","height":69,"width":198,"blurWidth":0,"blurHeight":0};